import { render, staticRenderFns } from "./client-modify.vue?vue&type=template&id=23a0fd89&"
import script from "./client-modify.vue?vue&type=script&lang=js&"
export * from "./client-modify.vue?vue&type=script&lang=js&"
import style0 from "./client-modify.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports